import type { FunctionalFormFieldProps } from '@adornis/formfield/functional-form-field.js';
import { stateful } from '@adornis/functional-lit/stateful.js';
import { html, nothing } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import * as m from '../../../../localization/out/messages.js';
import { SoftSkills } from '../../../db/job-position.js';
import { translateEnum } from '../../translate-enum.js';

const translateEnumInternal = (et?: string) => {
  return translateEnum('job_form_enum', et);
};

// TODO (low prio)needs to handle label and placeholder if to be provided generally
export const RegisterMultiselectCheckboxes = ({
  maxItems,
  enumObject,
  items,
}: {
  maxItems?: number;
  enumObject?: Record<string, string>;
  items?: string[];
}) =>
  stateful((props: FunctionalFormFieldProps<any[]>) => {
    const emit = (next: string[]) => props.onPicked?.(next);
    const toggleItem = (s: string) => {
      if (props.value?.includes(s)) emit(props.value.filter((x: string) => x !== s));
      else emit([...(props.value ?? []), s]);
    };

    const candidates = items
      ? items
      : enumObject
        ? Object.entries(enumObject)
            .filter(([key]) => !['_class', '_isBaseQLEnum'].includes(key))
            .map(([, value]) => value as string)
        : Object.entries(SoftSkills)
            .filter(([key]) => !['_class', '_isBaseQLEnum'].includes(key))
            .map(([, value]) => value as string);

    return html`
      <div class="flex flex-col gap-2">
        ${maxItems ? html` <div class="text-xs opacity-60 mt-1 max-w-prose">${unsafeHTML(m.select_up_to({ maxItems }))}</div> ` : nothing}
        ${props.error ? html`<p class="text-xs text-error mt-1">${props.error}</p>` : nothing}
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-2 mt-2">
          ${candidates.map(
            s =>
              html`<label class="label cursor-pointer gap-3">
                <input
                  type="checkbox"
                  class="checkbox checkbox-sm"
                  .checked=${props.value?.includes(s)}
                  @change=${() => toggleItem(s)}
                  ?disabled=${
                    props.disabled ||
                    (maxItems !== undefined && !props.value?.includes(s) && (props.value?.length ?? 0) >= maxItems)
                  }
                />
                <span class="label-text whitespace-normal">${translateEnumInternal(s)}</span>
              </label>`,
          )}
        </div>
      </div>
    `;
  });
